// removed by extract-text-webpack-plugin
module.exports = {"block":"_1FcB8kdrjEXYnWmDt-F6oJ","open":"_23jXXfwLkETBSFzGQwfW-R","yellow":"_2LU6Bt8R13HfB-ObQma-e6","dropdown":"_2G4wAlzUQVMlHr6paansXP","overlay":"_2qtkjKRsD1Ea8z23zVgQtZ","arrow":"fSDflv495bkB_gvhyL7w8","close":"izVMV33y96sKupgaktlrm","dropdown-item":"r-cQv7_kqCZQ-w5xO8Hhr","zebra":"_1K8EboAeFVRnKGCVcLu7l-","single":"_2AZR4rd9rMJ7gIoaAIWasu","active":"_2V_R9j9Ax0gaugam-IXxQp","dropdown-group":"_1tUobHDSOu7FR2LdH4PFhr","dropdown-check":"_2qMWUP_EZ831jTcst8o4_w","number":"E7TS7E8sCPTet6SxK2wAs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownFilter/DropdownFilter.module.scss
// module id = 753
// module chunks = 0